import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { EditPackageGuardComponent } from './edit-package-guard.component';
import { SettingsEditPackageService } from '../edit-package.service';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;
}

@Injectable()
export class CanDeactivateEditPackageGuard {
  submitted: boolean = false;
  constructor(
    private dialog: MatDialog,
    private settingsEditPackageService: SettingsEditPackageService,
  ) {}

  canDeactivate() {
    if (this.submitted || !this.settingsEditPackageService.formGroup?.dirty) {
      this.submitted = false;
      return true;
    }
    return this.confirmDialog();
  }

  async confirmDialog(): Promise<any> {
    let result: boolean;
    const dialogRef = this.dialog.open(EditPackageGuardComponent, {
      width: '612px',
      height: '188px',
      panelClass: 'padding-0',
    });
    await dialogRef.componentInstance?.onLeavePage.subscribe((value) => {
      result = value;
    });
    return dialogRef
      .afterClosed()
      .toPromise()
      .then(() => {
        return result;
      });
  }

  onSubmit(status: boolean): void {
    this.submitted = status;
  }
}
